/**
 * @generated SignedSource<<f4f2acb758311e9eacbf3c99a8c62b79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormattedDate$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useFormattedDate">;
  readonly " $fragmentType": "FormattedDate";
};
export type FormattedDate$key = {
  readonly " $data"?: FormattedDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FormattedDate",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFormattedDate"
    }
  ],
  "type": "Date",
  "abstractKey": "__isDate"
};

(node as any).hash = "52dd7d0fb236d5484f0157e67309fd6c";

export default node;
